import React, { useState, useEffect } from 'react';
import './../../style/css/navigation.css';

interface Props {
    onStateChange: (isOpen: boolean) => void
    isOpen: boolean;
}

export const NavigationBurger = (props: Props) => {
    /*const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {

    }, [isOpen]);

    const onClick = () => {
        setIsOpen(!isOpen);

        if(props.onStateChange){
            props.onStateChange(!isOpen);
        }
    }*/

    return (
        <div className={('navigation-burger') + (props.isOpen ? ' navigation-burger-active' : '')}
             onClick={() => props.onStateChange(!props.isOpen)}>
            <div className="top-line"></div>
            <div className="center-line"></div>
            <div className="bottom-line"></div>
        </div>
    )
};